module.exports = __webpack_public_path__ + "img/GBPAUD.c6871d79.png";